export const paymentMigrations = [
  {
    id: '037_platform_settings_and_meeting_payments',
    sql: `
      CREATE TABLE IF NOT EXISTS platform_settings (
        singleton BOOLEAN PRIMARY KEY DEFAULT TRUE CHECK (singleton),
        loading_message TEXT NOT NULL DEFAULT 'خطوة هادئة نحو تعارف جاد وآمن',
        fee_notice TEXT NOT NULL DEFAULT 'تُستخدم رسوم الجلسة لتوفير لقاء فيديو آمن ومنظّم ودعم المتابعة الفنية.',
        sham_cash_enabled BOOLEAN NOT NULL DEFAULT TRUE,
        sham_cash_currency TEXT NOT NULL DEFAULT 'USD',
        sham_cash_fees JSONB NOT NULL DEFAULT '{"1":"10.00","2":"8.00","3":"6.00"}'::jsonb,
        sham_cash_qr_encrypted TEXT,
        sham_cash_qr_mime TEXT,
        paypal_enabled BOOLEAN NOT NULL DEFAULT TRUE,
        paypal_currency TEXT NOT NULL DEFAULT 'EUR',
        paypal_fees JSONB NOT NULL DEFAULT '{"1":"10.00","2":"8.00","3":"6.00"}'::jsonb,
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        updated_by UUID REFERENCES users(id) ON DELETE SET NULL
      );
      INSERT INTO platform_settings (singleton) VALUES (TRUE) ON CONFLICT DO NOTHING;

      ALTER TABLE meeting_proposals ADD COLUMN session_number SMALLINT;
      WITH ranked AS (
        SELECT id, LEAST(3, ROW_NUMBER() OVER (PARTITION BY journey_id ORDER BY created_at, id))::smallint AS value
        FROM meeting_proposals
      )
      UPDATE meeting_proposals meeting SET session_number=ranked.value
      FROM ranked WHERE meeting.id=ranked.id AND meeting.session_number IS NULL;
      ALTER TABLE meeting_proposals ALTER COLUMN session_number SET DEFAULT 1;
      ALTER TABLE meeting_proposals ALTER COLUMN session_number SET NOT NULL;
      ALTER TABLE meeting_proposals DROP CONSTRAINT IF EXISTS meeting_proposals_session_number_check;
      ALTER TABLE meeting_proposals ADD CONSTRAINT meeting_proposals_session_number_check
        CHECK (session_number BETWEEN 1 AND 3);

      CREATE TABLE IF NOT EXISTS meeting_payment_obligations (
        meeting_id UUID NOT NULL REFERENCES meeting_proposals(id) ON DELETE CASCADE,
        beneficiary_user_id UUID NOT NULL REFERENCES users(id) ON DELETE CASCADE,
        paid_by_user_id UUID REFERENCES users(id) ON DELETE SET NULL,
        method TEXT CHECK (method IN ('sham_cash', 'paypal')),
        status TEXT NOT NULL DEFAULT 'pending'
          CHECK (status IN ('pending', 'submitted', 'paid', 'rejected')),
        amount NUMERIC(12,2),
        currency TEXT,
        provider_order_id TEXT,
        payment_reference_encrypted TEXT,
        proof_encrypted TEXT,
        reviewed_by UUID REFERENCES users(id) ON DELETE SET NULL,
        reviewed_at TIMESTAMPTZ,
        admin_note TEXT NOT NULL DEFAULT '',
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        PRIMARY KEY (meeting_id, beneficiary_user_id)
      );
      CREATE UNIQUE INDEX IF NOT EXISTS meeting_payment_provider_order_idx
        ON meeting_payment_obligations(provider_order_id) WHERE provider_order_id IS NOT NULL;
      CREATE INDEX IF NOT EXISTS meeting_payment_review_idx
        ON meeting_payment_obligations(status, updated_at DESC);
    `,
  },
] as const;
